import type { TutorPaymentPolicySelectReturn } from './interfaces'

import { TutorCategoryType } from '@entities/tutor'

import { usePaymentPoliciesStore } from './store'
import { useTutorPaymentPolicySelect } from './tutor-payment-policy-select.hook'

export const useSelectPaidMath = (): TutorPaymentPolicySelectReturn => {
  const paymentPoliciesStore = usePaymentPoliciesStore()

  return useTutorPaymentPolicySelect({
    category: TutorCategoryType.PaidMath,
    label: 'Paid Math',
    getValue: () => paymentPoliciesStore.selectedPaidMath as number | null,
    setValue: (value) => paymentPoliciesStore.setSelectedPaidMath(value),
  })
}
